import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {AreaFromShapeModel} from '../../../../../models/questions/subModels/areaFromShape.model';
import {EvoListSelectorService} from '../../../../../shared/modals/evo-list-selector/evo-list-selector.service';
import {AnswerContainerComponent} from '../../../../../platform/pages/answers/answer-container/answer-container.component';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-area-from-shape',
  templateUrl: './evo-area-from-shape.component.html',
  styleUrls: ['./evo-area-from-shape.component.css']
})
export class EvoAreaFromShapeComponent implements OnInit {

  AnswerContainer = AnswerContainerComponent;

  @Input() question: QuestionModel = new AreaFromShapeModel();

  constructor(private selectorSv: EvoListSelectorService) { }

  ngOnInit() {
  }

  castedQuestion(): AreaFromShapeModel {

    return <AreaFromShapeModel>this.question;

  }

  showQuestion(): boolean {

    if (this.question) {
      if (this.question.subCategory === Enums.QuestionSubcategories.areaFromShape) {
        return true;
      }
    }

    return false;

  }

  removeShape(index: number) {
    if (index < this.castedQuestion().model.shapes.length) {
      this.castedQuestion().model.shapes.splice(index, 1);
    }
  }

  showSelector() {
    this.selectorSv.showList(Enums.AreaShapes.list(),
      this.castedQuestion().model.shapes).subscribe((shape) => {
      if (shape) {
        this.castedQuestion().model.shapes.push(shape);
      }
    });
  }

}
